import { render, staticRenderFns } from "./newOldPwd.vue?vue&type=template&id=389bcaee&scoped=true&"
import script from "./newOldPwd.vue?vue&type=script&lang=js&"
export * from "./newOldPwd.vue?vue&type=script&lang=js&"
import style0 from "./newOldPwd.vue?vue&type=style&index=0&id=389bcaee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389bcaee",
  null
  
)

export default component.exports